import { QuantifyReportDataPointBase } from '@modules/quantify/store/types';

interface GetQuantifyBarLabelWidthBufferParams<T> {
  data: T[];
  dataPoint: T;
}

export const getQuantifyBarLabelWidthBuffer = <
  T extends QuantifyReportDataPointBase,
>({
  data,
  dataPoint,
}: GetQuantifyBarLabelWidthBufferParams<T>) => {
  let buffer = 0;

  if (dataPoint.category) {
    buffer += 18;
  }

  const hasCooccurringDataPoints = data.some(
    (dataPoint) => !dataPoint.isRelevant,
  );

  if (hasCooccurringDataPoints) {
    buffer += 18;
  }

  if (dataPoint.isUpdateInProgress) {
    buffer += 18;
  }

  return buffer;
};
